var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { sprintf } from "sprintf-js";
import GenericDictionary from "../genericDictionary";
var validationRules = new GenericDictionary();
export var validateRecord = function (record, fieldMetadataMap, fieldRulesMap, t) {
    var result = new Map();
    fieldMetadataMap.forEach(function (field, fieldName) {
        var fieldValidationResult = validateField(record, fieldMetadataMap, fieldRulesMap, fieldName, t);
        if (fieldValidationResult.length > 0) {
            result.set(fieldName, fieldValidationResult);
        }
    });
    return result;
};
export var validateField = function (record, fieldMetadataMap, fieldRulesMap, fieldName, t) {
    var validationResults = [];
    var fieldRules = fieldRulesMap.get(fieldName);
    var translate = t ? t : function (key) { return key; };
    if (!fieldRules) {
        return [];
    }
    fieldRules.forEach(function (rule) {
        if (typeof rule !== "string") {
            var result_1 = rule(record, fieldMetadataMap, fieldName, translate);
            console.log("result : ", result_1);
            if (result_1 === true) {
                return;
            }
            validationResults.push(typeof result_1 === "string"
                ? result_1
                : translate("validation.error.function"));
            return;
        }
        // string
        var args = rule.split(":");
        if (args.length <= 0) {
            return;
        }
        var ruleName = args.shift() || "";
        var ruleFunction = validationRules.get(ruleName);
        if (!ruleFunction) {
            return;
        }
        var result = ruleFunction.apply(void 0, __spreadArray([record,
            fieldMetadataMap,
            fieldName,
            translate], args, false));
        if (result === true) {
            return;
        }
        validationResults.push(typeof result === "string"
            ? result
            : sprintf(translate("validation.error.rule"), { rule: ruleName }));
    });
    return validationResults;
};
export default validationRules;
